import Section from 'components/Section';
import AuthTitle from 'components/AuthTitle';
import { Typography } from '@mui/material';
import Subtitle from 'components/Subtitle';
import { useTranslation } from 'react-i18next';
import styles from '../styles.module.css';

export default function PrivacyPolicySpanish() {
  const { t } = useTranslation();

  return (
    <Section className={styles.section}>
      <AuthTitle>{t('auth.privacy-policy-es.title00')}</AuthTitle>

      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.privacy-policy-es.text00')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text01')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text02')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text03')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.privacy-policy-es.title01')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.privacy-policy-es.text04')}
        <br />
        <br />
        <span className={styles.warning}>{t('auth.privacy-policy-es.text05')}</span>
        <br />
        <br />
        {t('auth.privacy-policy-es.text06')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text07')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.privacy-policy-es.title03')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.privacy-policy-es.text08')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text09')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text10')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text11')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.privacy-policy-es.title04')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.privacy-policy-es.text12')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text13')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text14')}
        <br />
        <br />
        {t('auth.privacy-policy-es.text15')}
        <br />
        <br />
      </Typography>
    </Section>
  );
}
